import { IN_PROGRESS, IN_STATUS_CHECK, INVOICES } from "global/paths";

const TYPE_TO_TARGET = {
  bulk_add_several_employees_failed: IN_PROGRESS,
  bulk_update_several_employees_failed: IN_PROGRESS,
  bulk_change_multiple_employee_status_failed: IN_STATUS_CHECK,
  invoice_due_t_minus_3: INVOICES,
  invoice_due_t_minus_1: INVOICES,
  invoice_due_t_0: INVOICES,
  invoice_overdue: INVOICES,
};

const REDIRECT_TARGET_ALIASES = {
  "bulk-add": IN_PROGRESS,
  "bulk-update": IN_PROGRESS,
  "bulk-status": IN_STATUS_CHECK,
  [IN_PROGRESS]: IN_PROGRESS,
  [IN_STATUS_CHECK]: IN_STATUS_CHECK,
  [INVOICES]: INVOICES,
};

const buildSearchAndState = (redirectParams = {}) => {
  const params = Object.entries(redirectParams).filter(
    ([, value]) => value !== null && value !== undefined && value !== "",
  );

  if (params.length === 0) return { search: "", state: {} };

  const query = new URLSearchParams();
  params.forEach(([key, value]) => query.set(key, String(value)));

  return {
    search: `?${query.toString()}`,
    state: Object.fromEntries(params),
  };
};

export const getNotificationNavigation = (item = {}) => {
  const rawTarget = item?.redirectatTarget || item?.redirecttarget || item?.redirectTarget;
  const target = REDIRECT_TARGET_ALIASES[rawTarget] || rawTarget || TYPE_TO_TARGET[item?.type];
  if (!target) return null;

  const { search, state } = buildSearchAndState(item?.redirectParams || {});

  return {
    target,
    search,
    state,
  };
};
